import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
  selector: 'app-filter-option-toggle',
  templateUrl: './filter-option-toggle.component.html',
  imports: [
    MatCheckbox,
    ReactiveFormsModule,
    NgClass,
    NgIf
  ],
  styleUrls: ['./filter-option-toggle.component.scss']
})
export class FilterOptionToggleComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() controlName: string;
  @Input() label: string;
  @Input() icon: string;
  @Output() toggle = new EventEmitter<boolean>();
  formControl!: FormControl;

  constructor() { }

  ngOnInit(): void {
    this.formControl = this.formGroup.get(this.controlName) as FormControl;
  }

  toggleControl() {
    this.formControl.setValue(!this.formControl.value);
    this.toggle.emit(this.formControl.value);
  }
}
